<script lang="ts">
	//Hooks
	import { onDestroy, createEventDispatcher } from 'svelte';
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Text, Modal, Collapse, Button, Container } from '@Shelly/shelly-design-system';
	//Helpers
	import { ScripsHelper } from '../scripts_helpers';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	//Components
	import ScriptsHighlight from './ScriptsHighlight.svelte';
	//Snippets
	import snippets from './snippets.json';
	//Types
	import type { ScriptSnippets } from '../../../../types/requests/settings/scripts';

	export let showModal = false;

	//@ts-ignore
	const snippetsList: ScriptSnippets = snippets,
		dispatch = createEventDispatcher(),
		insertCode = async (code: string) => {
			showModal = false;
			dispatch('insertScript', code);
		},
		collapseAll = (snippet: string = null) => {
			Object.keys(snippetsList).forEach((i) => {
				Object.keys(snippetsList[i].child).forEach((c) => {
					if (c != snippet) snippetsList[i].child[c].expanded = false;
				});
			});
		};

	onDestroy(collapseAll);
</script>

{#if showModal}
	<Modal
		bind:showModal
		backdropClose={false}
		title={$format('snippets', {
			default: 'Snippets',
		})}
		on:close={() => (showModal = false)}
	>
		<svelte:fragment slot="content">
			{#if snippets}
				{#each Object.keys(snippetsList) as category, i}
					{@const cat = snippetsList[category]}
					<Container
						padding="0"
						class={classMap({
							'mb-m': i < Object.keys(snippetsList).length - 1,
						})}
					>
						{#each Object.keys(cat.meta.docs) as link}
							<div
								class="d-flex flex-wrap align-items-center justify-content-between mb-s"
							>
								<Text element="h2" class="mb-s width-md-auto width-sm-full">
									{category}
								</Text>
								<Button
									class="mb-s width-md-auto width-sm-full"
									size="m"
									icon="fa-solid fa-arrow-up-right-from-square"
									href={cat.meta.docs[link]}
									target="_blank"
									on:click={ScripsHelper.openDocsLink}
								>
									{$format('button-docs-label', { default: 'Docs:' })}
									{link}
								</Button>
							</div>
						{/each}
						{#each Object.keys(cat.child) as snippet, snippetIndex}
							{@const item = cat.child[snippet]}
							<Collapse
								id="collapse-bcyk1ii"
								title={snippet}
								class={classMap({
									'mb-s': snippetIndex < Object.keys(cat.child).length - 1,
									'width-full': true,
								})}
								expanded={item.expanded}
								on:click={() => {
									collapseAll(snippet);
									snippetsList[category].child[snippet].expanded =
										!snippetsList[category].child[snippet].expanded;
								}}
							>
								<ScriptsHighlight code={item.code} />
								<div class="buttons-container-styles">
									<Button
										size="m"
										class="button-styles"
										icon="fas fa-plus"
										on:click={() => insertCode(item.code)}
									>
										{$format('insert_code', { default: 'Insert code' })}
									</Button>
									{#each Object.keys(item.meta.docs) as link}
										{#if item.meta.showButtonDocs}
											<Button
												variant="secondary"
												size="m"
												class="button-styles"
												icon="fa-solid fa-arrow-up-right-from-square"
												href={item.meta.docs[link]}
												target="_blank"
												on:click={ScripsHelper.openDocsLink}>{link}</Button
											>
										{/if}
									{/each}
								</div>
							</Collapse>
						{/each}
					</Container>
				{/each}
			{:else}
				<Text styleType="body" class="text-center text-bold mt-l mb-l">
					{$format('loading', {
						default: 'Loading ...',
					})}
				</Text>
			{/if}
		</svelte:fragment>
	</Modal>
{/if}

<style>
	/* layout styles for snippets containers */
	.buttons-container-styles {
		display: flex;
		flex-wrap: wrap;
	}

	:global(.button-styles) {
		margin-top: var(--spacing-s) !important;
		margin-right: var(--spacing-s) !important;
	}

	:global(.button-styles:last-child) {
		margin-right: 0 !important;
	}

	@media (max-width: 639px) {
		.buttons-container-styles {
			flex-direction: column-reverse;
		}

		:global(.button-styles) {
			margin-right: 0 !important;
		}
	}
</style>
